import { Button, ButtonProps } from "@faire/web--source/slate/Button";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
import styled from "styled-components";

import { BackToDestination } from "./types";
import { useBackToCtaContextMap } from "./useBackToCtaContextMap";

interface IBackToCtaProps extends Pick<ButtonProps, "variant" | "onClick"> {
  destination?: BackToDestination;
}

export const BackToCta: React.FC<IBackToCtaProps> = ({
  destination,
  variant,
  onClick,
}) => {
  const { backToCtaContextMap } = useBackToCtaContextMap();
  const backToCtaContext =
    backToCtaContextMap[destination ?? BackToDestination.FAIRE];

  if (!backToCtaContext?.label) {
    return null;
  }

  return (
    <BackToButton
      variant={variant}
      onClick={onClick}
      linkTo={backToCtaContext?.linkTo}
    >
      {backToCtaContext?.label}
    </BackToButton>
  );
};

const BackToButton = styled(Button)`
  ${responsiveMediaQueries.tabletAndAbove} {
    width: fit-content;
  }

  ${responsiveMediaQueries.mobile} {
    width: 100%;
  }
`;
